import mutations from "./AlarmsMutations";
import actions from "./AlarmsActions";
import getters from "./AlarmsGetters";
import Log from "./logs/AlarmsLogModule";

export default {
	namespaced: true,
	state:      () => ({
		alarms: [],
		toast:  {
			show:    false,
			message: "",
			type:    0
		},
		assets:         [],
		statuses:       [],
		selectedAssets: [],
	}),
	mutations,
	actions,
	getters,
	modules: { Log }
};
